<script>
    import { onMount, onDestroy } from "svelte";
    import * as api from "../stores/dspMng.store";
    import { login_id } from "../stores/auth.store";
    import Header from "../components/Header.svelte";

    let barcodeInput_1;
    let barcodeInputValue_1 = "";
    let scanTimeout;
    let interval;
    let isPaused = false;

    let getDate = new Date().toISOString().slice(0, 10); // 입고일자

    // 신규
    let dlivy_de = "";
    let dlivy_no = "";
    let wrhous_code = "";
    let wrhous_nm = "";
    let wrkshp_code = "";
    let wrkshp_nm = "";

    // 출고전표(거래명세서) 바코드 리딩
    let barcodeList = [];

    let total_qy = 0; // 발주 수량 total

    // 창고 선택 팝업창
    let wrhousList = [];

    // 작업작 선택 팝업창
    let wrkshpList = [];

    function manageFocus() {
        if (isPaused) return;

        if (barcodeInputValue_1 === "") {
            barcodeInput_1.focus();
            barcodeInput_1.click();
        }
    }

    onMount(() => {
        interval = setInterval(manageFocus, 1000);
    });

    onDestroy(() => {
        clearInterval(interval);
        clearTimeout(scanTimeout);
    });

    function inputBarcode(event) {
        clearTimeout(scanTimeout);

        scanTimeout = setTimeout(async function () {
            if (
                event.target.id === "barcode_1" ||
                barcodeInputValue_1.trim() === ""
            ) {
                if (barcodeInputValue_1.trim() !== "") {
                    if (wrkshp_code == "") {
                        alert("신규를 먼저 생성해주세요.");
                        barcodeInputValue_1 = "";
                        return;
                    }

                    const response =
                        await api.apiGetDspMng(barcodeInputValue_1);

                    if (response == "" || response == null) {
                        barcodeInputValue_1 = "";
                        return;
                    }

                    if (
                        barcodeList.some(
                            (barcode) =>
                                barcode.item_code === barcodeInputValue_1
                        )
                    ) {
                        barcodeList.forEach((barcode) => {
                            if (barcode.item_code === barcodeInputValue_1) {
                                barcode.qy++;
                            }
                        });
                    } else {
                        barcodeList.push({
                            id: barcodeList.length + 1,
                            item_code: barcodeInputValue_1,
                            dlivy_sn: barcodeList.length + 1,
                            item_nm: response.item_nm,
                            stndrd: response.stndrd,
                            unit_code: response.unit_code,
                            qy: 1,
                        });
                    }

                    total_qy++;
                    barcodeList = [...barcodeList];

                    barcodeInputValue_1 = "";
                }
            }
        }, 900);
    }

    function chk_on(id) {
        var del_num_tr = document.getElementById(id);
        var del_num = id.split("tr_")[1];
        var del_num_on = "chk_" + del_num;
        var del_num_chk = document.getElementById(del_num_on);

        if (del_num_tr.classList.contains("on")) {
            del_num_tr.classList.remove("on");
            del_num_chk.checked = false;
        } else {
            del_num_tr.classList.add("on");
            del_num_chk.checked = true;
        }
    }

    function deleteList() {
        let elements = document.querySelectorAll(".on");

        if (elements.length == 0) {
            alert("선택한 품목이 없습니다.");
            return;
        }

        // 각 요소를 반복하여 출력합니다.
        elements.forEach((element) => {
            let idToDelete = element.id.split("tr_")[1];

            barcodeList = barcodeList.filter((item) => item.id != idToDelete);

            barcodeList = [...barcodeList];
        });

        reallocation();

        // 선택된 on 모두 삭제
        elements = document.querySelectorAll(".on");
        elements.forEach((element) => {
            element.classList.remove("on");
        });
    }

    // 삭제된 요소 이후의 id 값을 재할당합니다.
    function reallocation() {
        total_qy = 0;

        for (let i = 0; i < barcodeList.length; i++) {
            barcodeList[i].id = i + 1;
            barcodeList[i].dlivy_sn = i + 1;
            total_qy += barcodeList[i].qy;
        }
    }

    function deleteAll() {
        barcodeInputValue_1 = "";
        dlivy_no = "";
        dlivy_de = "";
        wrhous_code = "";
        wrhous_nm = "";
        wrkshp_code = "";
        wrkshp_nm = "";
        total_qy = 0;
        barcodeList = [];
    }

    async function postDspMng() {
        if (barcodeList.length == 0) {
            alert("출고 품목이 없습니다.");
            return;
        }

        if (
            !(await api.apiPostDspMng(
                dlivy_no,
                dlivy_de,
                wrhous_code,
                wrhous_code.split("-")[0],
                wrhous_code.split("-")[1],
                wrkshp_code,
                barcodeList
            ))
        ) {
            return;
        }

        alert("출고 등록되었습니다.");

        deleteAll();
    }

    async function apiGetDspMngDetail() {
        const response = await api.apiGetDspMngDetail();

        dlivy_de = getDate;
        dlivy_no = response["dlivy_no"];

        wrhousList = [
            ...response["wrhous_list"].map((item, index) => ({
                id: wrhousList.length + index + 1,
                wrhous_code: item.wrhous_code,
                wrhous_nm: item.wrhous_nm,
            })),
        ];

        wrkshpList = [
            ...response["wrkshp_list"].map((item, index) => ({
                id: wrkshpList.length + index + 1,
                wrkshp_code: item.wrkshp_code,
                wrkshp_nm: item.wrkshp_nm,
            })),
        ];
    }

    function pop() {
        if (
            dlivy_de != "" &&
            !confirm(
                "확인 시 입력한 내용이 초기화됩니다.\n신규로 생성하시겠습니까?"
            )
        ) {
            return;
        }

        apiGetDspMngDetail();

        document.querySelector(".background").className = "background show-use";
    }

    function pop_close() {
        document.querySelector(".background").className = "background";
    }

    function pop_select() {
        document.querySelector(".background_select").className =
            "background_select show-use";
    }

    function pop_select_close() {
        document.querySelector(".background_select").className =
            "background_select";
    }

    async function select_wrhous(input_wrhous_nm, input_wrhous_code) {
        wrhous_nm = input_wrhous_nm;
        wrhous_code = input_wrhous_code;

        pop_close();
        pop_select();
    }

    async function select_wrkshp(input_wrkshp_nm, input_wrkshp_code) {
        wrkshp_nm = input_wrkshp_nm;
        wrkshp_code = input_wrkshp_code;

        pop_select_close();
    }
</script>

<Header />

<div class="menu-title">
    <p class="info-title" style="text-align: center;">출 고 관 리</p>
</div>

<input
    placeholder="품목 라벨 바코드"
    bind:this={barcodeInput_1}
    bind:value={barcodeInputValue_1}
    on:input={inputBarcode}
    id="barcode_1"
    type="text"
    inputmode="none"
    style="touch-action: manipulation;
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;
    white-space: nowrap;
    clip-path: inset(100%);"
/>

<!-- style="touch-action: manipulation;
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;
    white-space: nowrap;
    clip-path: inset(100%);" -->

<!-- svelte-ignore a11y-click-events-have-key-events -->
<div class="main-wrap">
    <div class="top-info">
        <div class="top-info-wrap">
            <div class="top-info-in">
                <p class="top-info-l">출고일자</p>
                <p class="top-info-r">{dlivy_de}</p>
                <p class="btn-in" on:click={pop}>신규</p>
            </div>
            <div class="top-info-in">
                <p class="top-info-l">출고번호</p>
                <p class="top-info-r">{dlivy_no}</p>
            </div>
            <div class="top-info-in">
                <p class="top-info-l">창고</p>
                <p class="top-info-r">{wrhous_nm}</p>
            </div>
            <div class="top-info-in">
                <p class="top-info-l">작업장</p>
                <p class="top-info-r">{wrkshp_nm}</p>
            </div>
        </div>
    </div>

    <div class="list-dtl-wrap scroll-custom">
        <table>
            <tbody>
                <tr>
                    <th class="chk-box">checkbox</th>
                    <th>순번</th>
                    <th>품명</th>
                    <th>규격</th>
                    <th>출고수량</th>
                </tr>

                {#each barcodeList as data}
                    <tr
                        id="tr_{data.id}"
                        on:click={() => chk_on("tr_" + data.id)}
                    >
                        <td class="chk-box"
                            ><input type="checkbox" id="chk_{data.id}" /></td
                        >
                        <td>{data.dlivy_sn}</td>
                        <td>{data.item_nm}</td>
                        <td>{data.stndrd}</td>
                        <td>{data.qy}</td>
                    </tr>
                {/each}
            </tbody>
            <tfoot>
                <tr>
                    <td colspan="3">총계</td>
                    <td>{total_qy}</td>
                </tr>
            </tfoot>
        </table>
    </div>

    <div class="btn-h-wrap">
        <p on:click={postDspMng}>출고등록</p>
        <p class="del-btn" on:click={deleteList}>선택삭제</p>
        <p
            class="del-btn"
            on:click={() => {
                deleteAll();
            }}
        >
            초기화
        </p>
    </div>

    <!-- 창고 선택 팝업 -->
    <div class="background">
        <div class="window">
            <div class="popup">
                <div class="popup-hd">
                    <p>창고 선택</p>
                    <img
                        alt=""
                        src="resource/img/ico_close.png"
                        class="popup-close"
                        on:click={pop_close}
                    />
                </div>

                <div class="list-dtl-wrap list-dtl-wrap-pop">
                    <table>
                        <tbody>
                            <tr>
                                <th>창고명</th>
                                <th>창코 코드</th>
                            </tr>

                            {#each wrhousList as data}
                                <tr
                                    on:click={() => {
                                        select_wrhous(
                                            data.wrhous_nm,
                                            data.wrhous_code
                                        );
                                    }}
                                >
                                    <td>{data.wrhous_nm}</td>
                                    <td>{data.wrhous_code}</td>
                                </tr>
                            {/each}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>

    <!-- 작업장 선택 -->
    <div class="background_select">
        <div class="window">
            <div class="popup">
                <div class="popup-hd">
                    <p>작업장 선택</p>
                    <img
                        alt=""
                        src="resource/img/ico_close.png"
                        class="popup-close"
                        on:click={pop_select_close}
                    />
                </div>

                <div class="list-dtl-wrap list-dtl-wrap-pop">
                    <table>
                        <tbody>
                            <tr>
                                <th>작업장명</th>
                                <th>작업장 코드</th>
                            </tr>

                            {#each wrkshpList as data}
                                <tr
                                    on:click={() => {
                                        select_wrkshp(
                                            data.wrkshp_nm,
                                            data.wrkshp_code
                                        );
                                    }}
                                >
                                    <td>{data.wrkshp_nm}</td>
                                    <td>{data.wrkshp_code}</td>
                                </tr>
                            {/each}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>
